class SettingTabVM {
    icon: KnockoutComputed<string> | string;
    title: KnockoutComputed<string> | string;
    id: number;
    widgetTypes: WidgetType[];
    isDashboard: boolean;
    isDashboardWidget: boolean;
    visible: KnockoutObservable<boolean>;
    templateClass: string;

    constructor(title, icon, id, widgetTypes?: WidgetType[], isDashboard: boolean = false, isDashboardWidget = false, templateClass?: string) {
        this.icon = icon;
        this.title = title;
        this.id = id;
        this.widgetTypes = widgetTypes;
        this.isDashboard = isDashboard;
        this.isDashboardWidget = isDashboardWidget;
        this.visible = ko.observable(false);
        this.setVisibility();
        this.templateClass = templateClass;
    }

    setVisibility() {
        if (this.isDashboard) {
            this.visible(workbook.workbookConfig.activeTabOrWidget().tabOrWidget === TabOrWidgetEnum.Tab && workbook.workbookConfig.activeTab().tabType() === TabTypeEnum.Dashboard);
        }
        else {
            if (this.isDashboardWidget) {
                this.visible(workbook.workbookConfig.activeTabOrWidget().tabOrWidget === TabOrWidgetEnum.Widget);
            }
            else {
                if (this.widgetTypes) {
                    let containsType = this.widgetTypes.find(x => x === workbook.workbookConfig.activeTabOrWidget().widgetType());
                    this.visible(containsType !== undefined ? true : false);
                }
                else {
                    this.visible(true);
                }
            }
        }
    }

}